import { useEffect, useState } from "react";

/**
 * Keeps only the active slide plus the immediately previous one mounted.
 * This avoids fetching every background/carousel image up front (they are
 * stacked inside the hero, so `loading="lazy"` alone does not defer them),
 * while preserving the crossfade between slides.
 */
export function useRenderedSlides(current: number, maxKept = 2): number[] {
  const [rendered, setRendered] = useState<number[]>([current]);

  useEffect(() => {
    setRendered((prev) => {
      if (prev.includes(current)) return prev;
      const next = [...prev, current];
      return next.length > maxKept ? next.slice(-maxKept) : next;
    });
  }, [current, maxKept]);

  return rendered;
}